<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Lote De Produção',
        :voltarPara='voltarPara',
        icon='el-icon-plus',
        btnTexto='Inserir Documentos',
    )
    .view-container-base-header
        FiltroRastreabilidade(
            textoPlaceHolder='Pesquisa inteligente (Busque por número do lote de producao ou fazenda)'
            @atualizar-filtro='atualizarFiltro'
        )
        
        .container-totalizadores
            h2 Total de lotes de produção cadastrados
            .totalizadores-lista
                div(v-for="item in this.dadosTotalizadores")
                    BaseCardTotalizadorRastreabilidade(
                        :texto='item.descricaoTotalizador',
                        :numero='item.totalLoteProducaoCadastrado',
                        :data='item.ultimaAtualizacaoLoteProducaoCadastrado'
                        icone='producao'
                    )

        BotoesDeAcoesRastreabilidade(
            btnPlaceHolder='Inserir Lote de produção'
            @btnInserirClicado='openModalArquivo'
            @btnBaixarModeloClicado='baixarModeloArquivo'
        )
      
        TabelaLoteDeProducao(
            v-loading='buscandoLoteDeProducao',
            :dadosTabela='dadosTabela',
            :paginacao='paginacao',
            tipo='SOCIOAMBIENTAL',
            @atualizar-pagina='atualizarPagina',
            @atualizar-tabela='buscarLoteDeProducao'
        )
        ModalInsercaoArquivoLoteDeProducao(
            :show.sync='showModalArquivoLoteDeProducao'
            @sucessoUpload='atualizarDadosTela'
            @closeModal='closeModalArquivo'
        )
</template>
    
    <script>
    import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
    import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
    import TabelaLoteDeProducao from '@/components/rastreabilidadeRaizen/loteDeProducao/TabelaLoteDeProducao';
    import BotoesDeAcoesRastreabilidade from '@/components/rastreabilidadeRaizen/BotoesDeAcoesRastreabilidade';
    import BaseCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/BaseCardTotalizadorRastreabilidade';

    import RastreabilidadeLoteDeProducaoService from '@/services/RastreabilidadeLoteDeProducaoService';
    import RastreabilidadeDocumentosService from '@/services/RastreabilidadeDocumentosService';

    import ModalInsercaoArquivoLoteDeProducao from '@/components/rastreabilidadeRaizen/loteDeProducao/ModalInsercaoArquivoLoteDeProducao';

    export default {
        name: 'LoteDeProducao',
        components: {
            BaseHeaderRastreabilidade,
            FiltroRastreabilidade,
            TabelaLoteDeProducao,
            ModalInsercaoArquivoLoteDeProducao,
            BotoesDeAcoesRastreabilidade,
            BaseCardTotalizadorRastreabilidade
        },
        data() {
            return {
                showModalArquivoLoteDeProducao: false,
                nomeColumn: null,
                voltarPara: true,
                paginacao: {
                    direcao: null,
                    itensPorPagina: 20,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
                },

                filtros: '',
    
                dadosTabela: [],

                dadosTotalizadores: [],
    
                buscandoLoteDeProducao: true
            };
        },
        created() {
            this.buscarLoteDeProducao(0);
            this.buscarTotalizadoresLoteDeProducao();
        },
        methods: {
            btnHeaderClicado: function () {},
    
            async buscarLoteDeProducao(pagina) {
                this.buscandoLoteDeProducao = true;
                this.paginacao.pagina = pagina;
                await RastreabilidadeLoteDeProducaoService.buscar(
                    this.filtros,
                    this.paginacao
                ).then(({ data }) => {
                    this.dadosTabela = data.itens;
                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;
                    this.buscandoLoteDeProducao = false;
                });
            },

            async buscarTotalizadoresLoteDeProducao() {
                const { data } =
                    await RastreabilidadeLoteDeProducaoService.buscarTotalizadoresLoteDeProducao();
                this.dadosTotalizadores = data;
            },

            async baixarModeloArquivo() {
                    await RastreabilidadeDocumentosService.baixarModeloCsv('LOTE_PRODUCAO');
            },
    
            atualizarFiltro(dados) {
                this.filtros = dados;
                this.buscarLoteDeProducao(0);
            },
    
            atualizarPagina(pagina) {
                this.buscarLoteDeProducao(pagina);
            },

            openModalArquivo() {
                this.showModalArquivoLoteDeProducao = true;
            },
            
            closeModalArquivo() {
                this.showModalArquivoLoteDeProducao = false;
            },

            atualizarDadosTela() {
                this.buscarLoteDeProducao(0);
                this.buscarTotalizadoresLoteDeProducao();
            },
            ordenar(props) {
                this.paginacao.direcao = props.order;
                this.paginacao.ordernarPor = props.column.label;

                if (props.order === null) this.paginacao.ordernarPor = null;
                this.buscarLoteDeProducao(0);
            }
        }
    };
    </script>
    <style lang="scss" scoped>
    #rastreabilidade-raizen {
        .box-instrucao {
            float: left;
            height: 39px;
            margin-right: 14px;
            color: #3b3b3b;
            max-width: 269px;
            font-size: 13px;
    
            span {
                padding-left: 3px;
                color: #1989fa;
                text-decoration-line: underline;
            }
        }

        .container-totalizadores {
            padding: 20px 35px 0px 20px;

            h2 {
                margin-bottom: 10px;
                margin-top: 10px;
                color: var(--black);
                font-weight: bold;
            }
            .totalizadores-lista {
                width: 100%;
                height: 99px;
                margin: 0 auto;
                display: grid;
                gap: 12px;
                grid-template-columns: 33% 33% 33%;
            }

            .totalizadores-bloco {
                width: 32%;
            }
        }
    }
    </style>
